import { Component, output } from '@angular/core';

import { DRAWER_ANIMATE_DURATION } from 'ng-zorro-antd/drawer';
import { timer } from 'rxjs';

import { StoreService } from '@services/store.service';
import { BaseComponent } from '@base/base.component';

@Component({
    template: '',
    standalone: false
})
export class BaseDrawerComponent extends BaseComponent {
    closePanel  = output<any>();

    open: boolean = false;
    working: boolean = false;

    constructor(protected _store?: StoreService) {
        super(_store);
        timer(DRAWER_ANIMATE_DURATION).subscribe(() => {
            this.open = true;
            this.__cdr?.markForCheck();
            this.onPanelOpened();
        });
    }

    close(data?: any, keepOpened = false): void {
        if (!keepOpened) {
            this.open = false;
            this.__cdr?.markForCheck();
            timer(DRAWER_ANIMATE_DURATION).subscribe(() => this.onPanelClosed(data));
        }
        else {
            this.onPanelClosed(data);
        }
    }

    onPanelClosed(data?: any): void {
        this.closePanel.emit(data);
        this.__cdr?.markForCheck();
    }

    onPanelOpened(): void {}

}
